const state = {
  branchSchemeList: [],
  branchScheme: {
    branchSchemeId: undefined,
    headerForm: {},
  },
  branchSchemeDetail: [],
  linesGridData: {
    budgetCategory: null,
    budgetType: null,
  },
  branchSchemeLinesList: [],
  };
  
  export default state;